"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterstitialManagerBase = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const useInterstitialBase_hook_1 = require("./hooks/useInterstitialBase.hook");
const InterstitialManagerBase = ({ interstitialConfig, interstitialsRepository, }) => {
    const { interstitialData, type, showInterstitial } = (0, useInterstitialBase_hook_1.useInterstitialBase)(interstitialsRepository);
    if (!showInterstitial) {
        return null;
    }
    const Interstitial = interstitialConfig[type] || null;
    return (0, jsx_runtime_1.jsx)(Interstitial, { interstitialData: interstitialData?.data[type] });
};
exports.InterstitialManagerBase = InterstitialManagerBase;
//# sourceMappingURL=interstitialManagerBase.js.map